import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">{t('termsAndConditions.title')}</h1>
      <p className="text-sm text-gray-600 mb-8">{t('termsAndConditions.lastUpdated')}: January 17, 2025</p>

      <div className="prose prose-blue max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('termsAndConditions.introduction.title')}</h2>
          <p className="mb-4">{t('termsAndConditions.introduction.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('termsAndConditions.services.title')}</h2>
          <p className="mb-4">{t('termsAndConditions.services.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('termsAndConditions.userObligations.title')}</h2>
          <ul className="list-disc pl-6 mb-4">
            {t('termsAndConditions.userObligations.list', { returnObjects: true }).map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('termsAndConditions.intellectualProperty.title')}</h2>
          <p className="mb-4">{t('termsAndConditions.intellectualProperty.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('termsAndConditions.liability.title')}</h2>
          <p className="mb-4">{t('termsAndConditions.liability.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('termsAndConditions.termination.title')}</h2>
          <p className="mb-4">{t('termsAndConditions.termination.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('termsAndConditions.governing.title')}</h2>
          <p className="mb-4">{t('termsAndConditions.governing.content')}</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">{t('termsAndConditions.contact.title')}</h2>
          <p className="mb-4">{t('termsAndConditions.contact.content')}</p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;
